export function zonasSciales() {
    return [{
        "Nombre": "Zonas Húmedas",
        "link": "https://www.youtube.com/embed/jO96tapGm_4",
        "path": require("./../UI/miniatures/Zonas humedas.jpg")
    },
    {
        "Nombre": "Gimnasio",
        "link": "https://www.youtube.com/embed/SFhFRchOKEs",
        "path": require("./../UI/miniatures/Gimnasio.jpg")
    },
    {
        "Nombre": "Lavandería",
        "link": "https://www.youtube.com/embed/xQxNA0t9duU",
        "path": require("./../UI/miniatures/Lavanderia.jpg")
    },
    {
        "Nombre": "Salón de Bienestar",
        "link": "https://www.youtube.com/embed/Or4DkYezww0",
        "path":  require("./../UI/miniatures/Salon de bienestar.jpg")
    },
    {
        "Nombre": "Sala de Entretenimiento",
        "link": "https://www.youtube.com/embed/ZPw_Vd_2gRU",
        "path":  require("./../UI/miniatures/Salon de entretenimiento.jpg"),
    },
    {
        "Nombre": "Coworking",
        "link": "https://www.youtube.com/embed/wMkdz1H4NEQ",
        "path":  require("./../UI/miniatures/Coworking.jpg")
    },
    {
        "Nombre": "Sala de Lectura de Niños",
        "link": "https://www.youtube.com/embed/oPOx8yIxijQ",
        "path":  require("./../UI/miniatures/Salon de lectura infantil.jpg")
    },
    {
        "Nombre": "Sala de Lectura de Adultos",
        "link": "https://www.youtube.com/embed/3BEvWJSmDnQ",
        "path":  require("./../UI/miniatures/Salon de lectura para adultos.jpg")
    },
    {
        "Nombre": "Salón de Piñatas",
        "link": "https://www.youtube.com/embed/uf_vz1zht_U",
        "path":  require("./../UI/miniatures/Salon de piñatas.jpg")
    },
    {
        "Nombre": "Pet Park",
        "link": "https://www.youtube.com/embed/wZnmnMlAejY",
        "path":  require("./../UI/miniatures/Petpark.jpg")
    }
    ]
}
